import { render, staticRenderFns } from "./frmdashboard_epkartya.vue?vue&type=template&id=04172e2a&"
import script from "./frmdashboard_epkartya.vue?vue&type=script&lang=js&"
export * from "./frmdashboard_epkartya.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports